import { Box, Typography } from "@mui/material";
import { NavigationButton } from "@components";
import { ArrowBack } from "@mui/icons-material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { theme } from "@theme";

export const TaskError = (goToDashboard: () => void) => {
  return (
    <Box
      sx={{
        padding: "36px 58px",
        justifyItems: "center",
        textAlign: "center",
        background: theme.palette.info.light,
        borderRadius: 8,
        margin: "64px 64px",
      }}
    >
      <Box
        sx={{
          background: theme.palette.secondary.main,
          borderRadius: 5,
          padding: "48px 92px",
        }}
      >
        <ErrorOutlineOutlinedIcon
          sx={{
            width: 64,
            height: 64,
            color: theme.palette.primary.main,
            background: theme.palette.primary.light,
            borderRadius: "50%",
            padding: 1
          }}
        />
        <Typography
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            fontSize: "2rem",
            color: theme.palette.text.primary,
            fontWeight: 700,
            marginBottom: 3,
          }}
        >
          Error fetching specific Task
        </Typography>
        <NavigationButton
          startIcon={<ArrowBack />}
          type="button"
          onClick={goToDashboard}
        >
          Return to Dashboard
        </NavigationButton>
      </Box>
    </Box>
  );
};
